import { render, staticRenderFns } from "./formulario_consulta_campo_paragrafo.vue?vue&type=template&id=7a51be26&scoped=true&"
import script from "./formulario_consulta_campo_paragrafo.vue?vue&type=script&lang=js&"
export * from "./formulario_consulta_campo_paragrafo.vue?vue&type=script&lang=js&"
import style0 from "./formulario_consulta_campo_paragrafo.vue?vue&type=style&index=0&id=7a51be26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51be26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
